import React, { ComponentProps } from 'react';
import { Button as SButton } from 'semantic-ui-react';
import cx from 'classnames';

interface Props extends ComponentProps<typeof SButton> {
  outline?: boolean;
}

const Button: React.FC<Props> = (props) => (
  <SButton
    {...props}
    className={cx('iv--button', {
      'iv--button-outline': props.outline,
    })}
  />
);

export default Button;
